<div class="unauth-container">
    <div class="card">
        <div class="icon">🔒</div>
        <h1>Unauthorized Access</h1>
        <p>You don't have permission to view this page.</p>

        <button mat-raised-button color="primary" (click)="goHome()">
      Go to Home
    </button>
    </div>
</div>